// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { PharmacyGroupDrugsState } from '../_reducers/pharmacy-group-drug.reducers';
import { PharmacyGroupDrug } from '../_models/pharmacy-group-drug.model';

export const selectPharmacyGroupDrugsState =
  createFeatureSelector<PharmacyGroupDrugsState>('pharmacyGroupDrugs');

export const selectPharmacyGroupDrugById = (pharmacyGroupDrugId: number) =>
  createSelector(
    selectPharmacyGroupDrugsState,
    (pharmacyGroupDrugsState) => pharmacyGroupDrugsState.entities[pharmacyGroupDrugId],
  );

export const selectPharmacyGroupDrugsPageLoading = createSelector(
  selectPharmacyGroupDrugsState,
  (pharmacyGroupDrugsState) => {
    return pharmacyGroupDrugsState.listLoading;
  },
);

export const selectPharmacyGroupDrugsActionLoading = createSelector(
  selectPharmacyGroupDrugsState,
  (pharmacyGroupDrugsState) => pharmacyGroupDrugsState.actionsloading,
);

export const selectLastCreatedPharmacyGroupDrugId = createSelector(
  selectPharmacyGroupDrugsState,
  (pharmacyGroupDrugsState) => pharmacyGroupDrugsState.lastCreatedPharmacyGroupDrugId,
);

export const selectPharmacyGroupDrugsPageLastQuery = createSelector(
  selectPharmacyGroupDrugsState,
  (pharmacyGroupDrugsState) => pharmacyGroupDrugsState.lastQuery,
);
export const selectPharmacyGroupDrugError = createSelector(
  selectPharmacyGroupDrugsState,
  (pharmacyGroupDrugsState) => pharmacyGroupDrugsState.error,
);
export const selectPharmacyGroupDrugLatestSuccessfullAction = createSelector(
  selectPharmacyGroupDrugsState,
  (pharmacyGroupDrugsState) => pharmacyGroupDrugsState.latestSuccessfullAction,
);
export const selectPharmacyGroupDrugsInStore = createSelector(
  selectPharmacyGroupDrugsState,
  (pharmacyGroupDrugsState) => {
    const items = (pharmacyGroupDrugsState.ids as number[])
      .map((id) => pharmacyGroupDrugsState.entities[id])
      .filter((item): item is PharmacyGroupDrug => item !== undefined);
    return new QueryResultsModel(items, pharmacyGroupDrugsState.totalCount);
  },
);
export const selectPharmacyGroupDrugsShowInitWaitingMessage = createSelector(
  selectPharmacyGroupDrugsState,
  (pharmacyGroupDrugsState) => pharmacyGroupDrugsState.showInitWaitingMessage,
);

export const selectHasPharmacyGroupDrugsInStore = createSelector(
  selectPharmacyGroupDrugsState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
